import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@sshop/i18n';

import { useWishlist } from '@/features/wishlist';
import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';

import { wishlistButtonStyles as s } from './WishlistButton.styles';

export function WishlistButton() {
  const { t } = useTranslation();
  const locale = useLocale();
  const { data: wishlist } = useWishlist();
  const count = wishlist?.itemCount ?? 0;
  const display = count > 99 ? '99+' : String(count);

  return (
    <Link to={routes.favorites(locale)} aria-label={t('nav.favorites')} className={s.root}>
      <Heart className={s.icon} aria-hidden />
      {count > 0 && (
        <span className={s.badge} aria-hidden>
          {display}
        </span>
      )}
    </Link>
  );
}
